import React, { Component } from 'react';
import styleable from 'react-styleable';
import SortableTree from 'react-sortable-tree';
import PropTypes from 'prop-types';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import '../../styles/core.scss';
import css from './index.scss';

class SectionDetail extends Component {
    static propTypes = {
        sectionDetail: PropTypes.object,
        handleGoToListViewClick: PropTypes.func,
        handleRegisterMasterCourse: PropTypes.func
    };

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props !== nextProps || this.state !== nextState) {
            return true;
        }
        return false;
    }

    constructor(props) {
        super(props);
        this.state = {
            treeData: []
        };
        this.treeData = [];
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ treeData: nextProps.sectionDetail.nodes || [] });
        this.treeData = nextProps.sectionDetail.nodes;
    }

    componentDidMount() {
        this.state = { treeData: this.props.sectionDetail.nodes || [] };
        this.treeData = this.props.sectionDetail.nodes;
    }

    componentWillUnmount() {
        this.state = { treeData: [] };
        this.props.sectionDetail.sectionId = '';
    }

    handleOnChange(treeData) {
        this.treeData = treeData;
        this.setState({ treeData });
    }

    render() {
        return (
            <div className={css.sectionDetailComponent}>
                <button className={css.button} onClick={this.props.handleGoToListViewClick}>Go back to section list</button>
                <button className={css.button} onClick={this.props.handleRegisterMasterCourse}>Register as Master Course</button>
                <div className={css.standardTreeContainer}>
                    <SortableTree
                        canDrag={false}
                        generateNodeProps={({ node }) => ({
                            className: `${node.className}`
                        })}
                        onChange={this.handleOnChange}
                        treeData={this.treeData}
                    />
                </div>
            </div>
        );
    }
}

export default styleable(css)(SectionDetail);



// WEBPACK FOOTER //
// ./app/components/section-detail/index.js